export enum fundingTrackingDataActionTypes {
  STORE = 'STORE_fUNDING_TRACKING_DATA',
  POST = 'POST_fUNDING_TRACKING_DATA',
  PUT = 'PUT_fUNDING_TRACKING_DATA',
  GET = 'POST_USER_FUNDING_INFO',
  GENERATE = 'POST_TRANSFER_FORM_DATA',
}
